import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-search"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(-33.488 -320.904)",
      class: ""
    }, [
      _createElementVNode("circle", {
        cx: "53.1",
        cy: "340.6",
        r: "6.6",
        class: "icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("line", {
        x1: "64.5",
        x2: "59.3",
        y1: "351.9",
        y2: "347.3",
        class: "icon-fi--stroke-linecap-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }